module.exports = __webpack_public_path__ + "static/img/btn_zhaopian_nor@2x.5a59866.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/IdentitAuthentication/images/btn_zhaopian_nor@2x.png
// module id = 2ttL
// module chunks = 1